<app-navbar>
  <div left-side>
    <button mat-icon-button aria-label="Page d'accueil" matTooltip="Accueil" routerLink="/">
      <svg lucideHouse class="vanex-gold"></svg>
    </button>
    <app-menu-company></app-menu-company>
    <app-menu-salary-scale></app-menu-salary-scale>
    @if (!demo) {
      <app-menu-anomalies></app-menu-anomalies>
    }
    <app-menu-tours></app-menu-tours>
    <app-menu-settings></app-menu-settings>
  </div>
  <app-layout-buttons center></app-layout-buttons>

  <app-menu-user-button-item menu-user-items> </app-menu-user-button-item>
</app-navbar>
